module.exports = __webpack_public_path__ + "static/img/0009.b44a9cdf.png";